import { HTMLAttributes } from 'react'
import {
  FlexboxProps,
  GridProps,
  LayoutProps,
  MarginProps,
  PositionProps,
} from 'styled-system'

import { GapProps, TestIdProps } from 'designSystem/types/propTypes'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

type PaddingSize = 'sm' | 'md' | 'lg'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  FlexboxProps &
  GapProps &
  GridProps &
  LayoutProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  paddingSize?: PaddingSize
} & BaseProps

export default function PDSCard({
  paddingSize = 'lg',
  testId,
  ...props
}: Props) {
  const padding = CARD_PADDING[paddingSize] ?? CARD_PADDING.lg

  return (
    <PDSBox
      {...props}
      backgroundColor={COLOR.content}
      border={`1px solid ${COLOR.content_border}`}
      borderRadius={SIZE.s8}
      boxShadow="0px 1px 2px 1px rgba(0,0,0,0.1)"
      padding={padding}
      testId={testId}
    />
  )
}

const CARD_PADDING = {
  sm: SIZE.s8,
  md: SIZE.s16,
  lg: SIZE.s24,
}
